import React, { Component } from "react";
// ui
import { TextField } from 'rmwc/TextField';
import { IconButton } from 'rmwc/IconButton';

class SearchPanel extends Component {

    /*componentDidMount(){
        this.tf.focus();
    }*/
    /*
    inputRef={el => this.tf = el}
    */

    render() {
        const {searchText, onSearchChange, onSearchClose} = this.props;

        return (
            <div className={'theSoldiers--searchPanel'}>
                <TextField box
                           value={searchText}
                           onChange={e => onSearchChange(e.target.value)}
                           withLeadingIcon="search"
                           label="search soldiers"/>
                <IconButton icon="close"
                            onClick={onSearchClose}
                            label="clear search"/>
            </div>
        );
    }
}

export default SearchPanel;


// WEBPACK FOOTER //
// ./src/app/components/SearchPanel.js